// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b87395c5","285":"9c9915d6","415":"e6e9b90e","568":"5b407210","734":"4426b761"}[chunkId] + ".chunk.js";
};